import React from 'react';
import PropTypes from 'prop-types';
import styles from './Reading.module.scss';

const Reading = ({ reading }) => (
  <div className={styles.reading}>
    {reading.url ?
      <a href={reading.url} target="_blank" rel="noopener noreferrer">
        <strong>{reading.title}</strong>
        {reading.extra ? <span>, {reading.extra}</span> : '' }
        {reading.author ? <span>, by {reading.author}</span>: '' }.
      </a>
      :
      <div>
        <strong>{reading.title}</strong>
        {reading.extra ? <span>, {reading.extra}</span> : '' }
        {reading.author ? <span>, by {reading.author}</span>: '' }.
      </div>
    }
  </div>
);

Reading.propTypes = {
  reading: PropTypes.array,
};

export default Reading;
